'use strict';

var React = require('react');

var SvgReturnMinor = function SvgReturnMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13h-8.086l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.997.997 0 0 1 1.414 0 .999.999 0 0 1 0 1.414l-1.293 1.293h8.086c1.379 0 2.5-1.121 2.5-2.5s-1.121-2.5-2.5-2.5h-10.5a1 1 0 1 1 0-2h10.5c2.481 0 4.5 2.019 4.5 4.5s-2.019 4.5-4.5 4.5z"
  }));
};

exports.SvgReturnMinor = SvgReturnMinor;
